import axiosWithoutInterceptor from '../../../../helpers/axios-without-interceptor'
import { Response } from '../../index'

export type VerifyCodeRequest = {
  code: string
}

export type VerifyCodeResponse = {
  isValid: boolean
  invalidCodeCause: InvalidCodeCause
  newCode: string
}

export enum InvalidCodeCause {
  IS_VALID = 'IS_VALID',
  EXPIRATED = 'EXPIRATED',
  WRONG_CODE = 'WRONG_CODE',
  ALREADY_USED = 'ALREADY_USED',
  WRONG_TYPE = 'WRONG_TYPE',
  CODE_IS_NOT_FOR_THE_EMAIL = 'CODE_IS_NOT_FOR_THE_EMAIL'
}

const verifyCode = (
  request: VerifyCodeRequest
): Response<VerifyCodeResponse> => {
  return axiosWithoutInterceptor.post(`/v1/users/passwords/codes`, request)
}

export default verifyCode
